import { AxiosResponse } from 'axios';
import Store from '@/store/index';
import Screen from '@/models/Screen';
import ScreenContent from '@/models/ScreenContent';

export default class ScreenService {
    public async LoadScreen(id: number) {
        const methodEndpoint = Store.state.basePath + Store.state.endpoints.screenLoad;

        try {
            const axios = require('axios').default;
            const response: AxiosResponse = await axios.get(`${methodEndpoint}?id=${id}`);

            let returnValue: Screen = new Screen();
            returnValue.Id = response.data.Id;
            returnValue.CustomerId = response.data.CustomerId;
            returnValue.Name = response.data.Name;
            returnValue.Active = response.data.Active;
            returnValue.DateUpdated = response.data.DateUpdated;
            returnValue.DateCreated = response.data.DateCreated;
            returnValue.CustomerName = response.data.CustomerName;
            returnValue.Contents = response.data.Contents.map((val: any) => {
                const item = new ScreenContent();
                item.Id = val.Id;
                item.ScreenId = val.ScreenId;
                item.ScreenType = val.ScreenType;
                item.ContentId = val.ContentId;
                return item;
            });

            return { Error: false, Data: returnValue };
        } catch (error) {
            return { Error: true, Message: error };
        }
    }

    public async AddScreen(screenInfo: Screen) {
        const postData = {
            CustomerId: screenInfo.CustomerId,
            Name: screenInfo.Name,
            Active: screenInfo.Active
        };

        const methodEndpoint = Store.state.basePath + Store.state.endpoints.screenAdd;

        try {
            const axios = require('axios').default;
            const response: AxiosResponse = await axios.post(methodEndpoint, postData);
            return { Error: false, Data: response.data.id };
        } catch (error) {
            return { Error: true, Message: error };
        }
    }

    public async UpdateScreen(screenInfo: Screen) {
        const postData = {
            Id: screenInfo.Id,
            Name: screenInfo.Name,
            Active: screenInfo.Active
        };

        const methodEndpoint = Store.state.basePath + Store.state.endpoints.screenUpdate;

        try {
            const axios = require('axios').default;
            const response: AxiosResponse = await axios.put(methodEndpoint, postData);
            return { Error: false, Data: null };
        } catch (error) {
            return { Error: true, Message: error };
        }
    }

    public async DeleteScreen(id: number) {
        const postData = {
            Id: id
        };

        const methodEndpoint = Store.state.basePath + Store.state.endpoints.screenDelete;

        try {
            const axios = require('axios').default;
            const response: AxiosResponse = await axios.put(`${methodEndpoint}?id=${id}`);
            return { Error: false, Data: null };
        } catch (error) {
            return { Error: true, Message: error };
        }
    }

    public async CreateEmptyDashboard(id: number) {
        const methodEndpoint = Store.state.basePath + Store.state.endpoints.screenEmptyDashboard;

        try {
            const axios = require('axios').default;
            const response: AxiosResponse = await axios.put(`${methodEndpoint}?id=${id}`);
            return { Error: false, Data: response.data };
        } catch (error) {
            return { Error: true, Message: error };
        }
    }
}
